// Utilitaires couleur — contraste WCAG + extraction depuis un logo.

export function hexToRgb(hex) {
  if (!hex) return { r: 0, g: 0, b: 0 };
  let h = hex.replace("#", "");
  if (h.length === 3) h = h.split("").map((c) => c + c).join("");
  const n = parseInt(h, 16);
  return { r: (n >> 16) & 255, g: (n >> 8) & 255, b: n & 255 };
}

export function relativeLuminance(hex) {
  const { r, g, b } = hexToRgb(hex);
  const f = (v) => {
    const s = v / 255;
    return s <= 0.03928 ? s / 12.92 : Math.pow((s + 0.055) / 1.055, 2.4);
  };
  return 0.2126 * f(r) + 0.7152 * f(g) + 0.0722 * f(b);
}

export function contrastRatio(hex1, hex2) {
  const l1 = relativeLuminance(hex1);
  const l2 = relativeLuminance(hex2);
  const [hi, lo] = l1 > l2 ? [l1, l2] : [l2, l1];
  return (hi + 0.05) / (lo + 0.05);
}

// Retourne "#FFFFFF" ou "#1F1F1F" selon le meilleur contraste (WCAG AA).
export function textOn(bgHex) {
  const white = contrastRatio(bgHex, "#FFFFFF");
  const ink = contrastRatio(bgHex, "#1F1F1F");
  return white >= ink ? "#FFFFFF" : "#1F1F1F";
}

// Extrait les 2 couleurs dominantes (non transparentes, non quasi-blanches) d'une image.
export function extractPalette(img) {
  const size = 60;
  const canvas = document.createElement("canvas");
  canvas.width = size;
  canvas.height = size;
  const ctx = canvas.getContext("2d");
  ctx.drawImage(img, 0, 0, size, size);
  const data = ctx.getImageData(0, 0, size, size).data;
  const buckets = {};
  for (let i = 0; i < data.length; i += 4) {
    const a = data[i + 3];
    if (a < 200) continue;
    const r = data[i], g = data[i + 1], b = data[i + 2];
    if (r > 240 && g > 240 && b > 240) continue; // ignore blanc
    if (r < 20 && g < 20 && b < 20) continue;     // ignore noir pur
    const key = `${Math.round(r / 24)}-${Math.round(g / 24)}-${Math.round(b / 24)}`;
    buckets[key] = buckets[key] || { count: 0, r: 0, g: 0, b: 0 };
    buckets[key].count++;
    buckets[key].r += r; buckets[key].g += g; buckets[key].b += b;
  }
  const sorted = Object.values(buckets).sort((a, b) => b.count - a.count);
  const toHex = (bk) => {
    const r = Math.round(bk.r / bk.count), g = Math.round(bk.g / bk.count), b = Math.round(bk.b / bk.count);
    return "#" + [r, g, b].map((v) => v.toString(16).padStart(2, "0")).join("");
  };
  const primary = sorted[0] ? toHex(sorted[0]) : "#2B2B2B";
  const secondary = sorted[1] ? toHex(sorted[1]) : "#8A8577";
  return { primary, secondary };
}
